// 提交和拿到的值需要做转换- 具体值
const submitServiceDataType = (field: Record<string, any>) => {
  switch (field.fieldType) {
    case 'upload':
    case 'custom-upload':
      return field?.fieldValue?.map((o: any) => o?.source || o?.url)?.join(',')
    case 'idNumber': // 身份证
      return field?.fieldValue ? JSON.stringify(field?.fieldValue) : undefined
    case 'carNumber': // 车牌号
      return field?.fieldValue ? field?.fieldValue?.join('') : undefined
    case 'select-single':
    case 'custom-select-single':
    case 'select-multiple': // 自定义
    case 'custom-select-multiple':
      return Array.isArray(field?.fieldValue) ? field?.fieldValue?.join?.(',') : field?.fieldValue
    case 'phone': // 如果是手机号的时候，需要看是否需要区域码，然后进行切割做
      if (field.fieldValue?.includes('-')) {
        const [area, phone] = field.fieldValue?.split('-')
        if (!phone) return ''
      }
      return field.fieldValue
    default:
      return field.fieldValue
  }
}
// 提交的值需要做转换- 展示值
const submitServiceDataTypeDisplayValue = (field: Record<string, any>) => {
  switch (field.fieldType) {
    case 'upload':
    case 'custom-upload':
      return field?.fieldValue?.map((o: any) => o?.fileName || o?.source || o?.url)?.join(',')
    case 'idNumber': // 身份证
      return field?.fieldValue ? JSON.stringify(field?.fieldValue) : undefined
    case 'carNumber': // 车牌号
      return field?.fieldValue ? field?.fieldValue?.join('') : undefined
    case 'select-multiple': // 自定义
    case 'custom-select-multiple':
      const _fieldValue = Array.isArray(field.fieldValue) ? field.fieldValue?.join?.(',') : field.fieldValue
      return Array.isArray(field.value) ? field.value?.join?.(',') : (field.value || _fieldValue)
    case 'select-single':
    case 'custom-select-single':
      return field.value

    case 'phone': // 如果是手机号的时候，需要看是否需要区域码，然后进行切割做
      if (field.fieldValue?.includes('-')) {
        const [area, phone] = field.fieldValue?.split('-')
        if (!phone) return ''
      }
      return field.fieldValue
    default:
      return field.fieldValue || field.value
  }
}

// 提交和拿到的值需要做转换
// 提交到服务器 -- 做转换
export function submitServiceData(data: Record<string, any>) {
  return data?.map((_: any) => {
    // raw multiple 场景下 id 带 _copy_ 后缀，groupName 末尾也带序号
    const isRawMultiple = String(_?.id || '').includes('_copy_')
    return {
      ..._,
      // 去掉酒店场景下前端复制时加的后缀，避免影响后端
      id: String(_?.id || '').replace(/_copy_\d+$/, ''),
      // 仅 raw multiple 场景去掉 groupName 末尾序号（如"酒店信息1"→"酒店信息"）
      groupName: isRawMultiple
        ? String(_?.groupName || '').replace(/\d+$/, '')
        : _?.groupName,
      fieldList: _?.fieldList?.map((item: Record<string, any>) => ({
        ...item,
        value: submitServiceDataTypeDisplayValue(item),
        fieldValue: submitServiceDataType(item),
        optionValue: undefined, // 删除不必要的字段，免得过大
        fieldTips: undefined,
        attributes: undefined
      })),
    }
  })
}

// 获取服务器数据转换- 单个
const getServiceDataType = (field: Record<string, any>) => {
  switch (field.fieldType) {
    case 'upload':
    case 'custom-upload':
      return field?.fieldValue?.split(',')?.map((o: string, index: number) => ({
        fileUrl: o,
        url: o,
        name: field?.value?.split(',')?.[index] || o,
      }))
    case 'select-multiple': // 自定义
    case 'custom-select-multiple':
      return typeof field?.fieldValue === 'string' ? field?.fieldValue?.split(',') : (field?.fieldValue || [])
    case 'idNumber': // 身份证
      return field?.fieldValue ? JSON.parse(field?.fieldValue) : undefined
    case 'carNumber': // 车牌号
      const areaCode = field?.fieldValue ? String(field?.fieldValue)?.substring(0, 2) : ''
      const numberCode = field?.fieldValue ? String(field?.fieldValue)?.substring(2, field?.fieldValue?.length) : ''
      return [areaCode, numberCode]
    default:
      return field.fieldValue
  }
}

//获取服务器数据转换 -- 主要获取到的图片以及说单多选需要转换
export function getServiceData(data: Record<string, any>) {
  return data?.map((_: any) => ({
    ..._,
    fieldList: _?.fieldList?.map((item: Record<string, any>) => ({
      ...item,
      fieldValue: getServiceDataType(item)
    }))
  }))
}

export const transformItem = (node: any) => typeof node === 'string' ? { label: node, value: node, key: node } : ({ label: node?.displayValue || node?.label, value: node.value, key: node.value })
/**
 * 判断是否为JSON
 * */
export const isJSONParseArray =  (str: any) => {
  if (typeof str === 'string'){
    try {
      const obj = JSON.parse(str)
      return obj?.map((node: any) => transformItem(node)) || []
    } catch (e){
      const obj = str?.split?.(',') || []
      return obj?.map((node: any) => transformItem(node)) || []
    }
  }
  return str?.map?.((node: any) => transformItem(node)) || []
}

/**
 * 判断是否为JSON
 * */
export const isJSONParse =  (str: string | null) => {
  if (typeof str === 'string'){
    try {
      return JSON.parse(str)
    } catch (e){
      return {}
    }
  }
  return str || {}
}

// 设置默认的用户信息
export function setUserDefault(record: Record<string, any>, memberInfo: Record<string, any>) {
  const relateConfigOpt = record?.relateConfigOpt?.split?.(',')
  const isAllowLink = relateConfigOpt?.includes('link')
  const isAllowEdit = relateConfigOpt?.includes('edit')
  const disabled = record?.relateConfig && isAllowLink && !isAllowEdit
  const options = isJSONParseArray(record?.optionValue)
  if (!record?.relateConfig) {
    return {
      fieldValue: undefined,
      value: undefined,
      disabled: false
    }
  }
  switch (record.relateConfig) {
    case 'memberPhone':
    case 'usePhone':
      let _prefix = '' // 需要手机号前缀
      if (memberInfo?.countryCode && record?.configType === '‌i18n‌Config') { // saas这边返回是没有-的做一下兼容
        _prefix = memberInfo?.countryCode?.includes('-') ? memberInfo?.countryCode : `${memberInfo?.countryCode}-`
      }
      const _isMobile = memberInfo?.['mobile'] ? `${_prefix}${memberInfo?.['mobile']}` : undefined
      return {
        fieldValue: isAllowLink ? _isMobile : undefined,
        value: undefined,
        disabled: Boolean(record?.disabled || (isAllowLink && _isMobile))
      }
    case 'memberName':
    case 'useName':
      return {
        fieldValue: isAllowLink ? (memberInfo?.['userName'] || undefined) : undefined,
        value: undefined,
        disabled: Boolean(record?.disabled || (isAllowLink && memberInfo?.['userName']))
      }
    case 'gender': // 
      return {
        fieldValue: isAllowLink ? memberInfo?.['gender'] : undefined,
        value: isAllowLink ? (memberInfo?.['genderName'] || options?.find?.((_: any) => _?.value === memberInfo?.['gender'])?.label) : undefined,
        disabled
      }
    case 'marriageStatus': // 
      return {
        fieldValue: isAllowLink ? memberInfo?.['marriageStatus'] : undefined,
        value: isAllowLink ? (memberInfo?.['marriageStatusName'] || options?.find?.((_: any) => _?.value === memberInfo?.['marriageStatus'])?.label) : undefined,
        disabled
      }
    case 'idNumber':
      let currentValue = {
        idTypeName: memberInfo?.['idTypeName'] || options?.find?.((_: any) => _?.value === memberInfo?.['idType'])?.label,
        idNumber: memberInfo?.['idNo'],
        idType: memberInfo?.['idType']
      }
      return {
        fieldValue: isAllowLink ? currentValue : undefined,
        value: isAllowLink ? JSON.stringify(currentValue) : undefined,
        disabled
      }
  }
}
